<div class="step-container columns is-desktop" [class.d-none]="isLoading">
  <app-aside-bar
    [showEvenWithoutStatement]="false"
    [statement]="statement"
    [workFlowController]="workFlowController"
  ></app-aside-bar>
  <div class="upsell-content">
    <h1 class="title"> Możesz zapłacić po wykonaniu usługi! </h1>
    <div class="content">
      <h3 class="content-title"> Korzystając z pakietu Premium płacisz tylko za sukces! </h3>
      <div class="wrapper">
        <div class="list-section">
          <ul class="feature-list">
            <li>Gwarancja najwyższego zwrotu podatku</li>
            <li>Przejmujemy cały kontakt z Finanzamt</li>
            <li>W tym momencie nic nie płacisz</li>
          </ul>
          <div class="description">
            <span class="percentage-info">Cena usługi to 19% Twojego zwrotu. </span>
            <span class="percentage-info bolded">Koszt zostanie potrącony po wykonaniu usługi.</span>
          </div>
        </div>
        <div class="image-section">
          <img src="../../../assets/svg/hand_cash.svg" />
        </div>
      </div>
    </div>
  </div>
  <app-tools-bar [buttons]="buttons" [alignRight]="true"></app-tools-bar>
</div>
